module.exports = __webpack_public_path__ + "static/media/group_19_2.25b7858d.jpg";